import React, { useContext } from 'react';
import BookerShortContext from '../../context/bookerShortContext';
import '../../assets/styles/addess-info.sass';

const AddressInfo = () => {
  const { ride } = useContext(BookerShortContext);
  const {
    pickup_line1,
    pickup_city,
    pickup_state,
    pickup_postal_code,
    dropoff_line1,
    dropoff_city,
    dropoff_state,
    dropoff_postal_code,
  } = ride || {};
  const pickupAddress = pickup_line1 ? `${pickup_line1}, ${pickup_city}, ${pickup_state} ${pickup_postal_code}` : '';
  const dropoffAddress = dropoff_line1
    ? `${dropoff_line1}, ${dropoff_city}, ${dropoff_state} ${dropoff_postal_code}`
    : '';

  if (!(pickupAddress && dropoffAddress)) return <></>;
  return (
    <>
      <div className="address-wrapper">
        <div>Your Pickup</div>
        <div className="address-info">{pickupAddress}</div>
      </div>
      <div className="address-wrapper">
        <div>Your Destination</div>
        <div className="address-info">{dropoffAddress}</div>
      </div>
    </>
  );
};

export default AddressInfo;
